import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getQuestionAnswersList(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/case/getQuestionAnswers${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getquestionAnswerById(id, caseType, token) {
  return axios.get(
    `${baseUrl}/case/getQuestionAnswersByUser/${id}/${caseType}`,
    {
      headers: {
        authorization: token,
      },
    }
  );
}

export function postApproveReject(token, data) {
  return axios.post(`${baseUrl}/case/approveQuestionnaire`, data, {
    headers: {
      authorization: token,
    },
  });
}
